import { InfoOutlined } from "@mui/icons-material";
import { CircularProgress, Stack, Typography } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import Snackbar from "@mui/material/Snackbar";
import { notificationAtom } from "atoms/notification";
import { useAtom } from "jotai";
import { ReactElement, useEffect } from "react";
import Alert from "shared/components/Alert";

function Notification(): ReactElement {
  const [notification, setNotification] = useAtom(notificationAtom);
  const { isOpen, inProgress, severity, message } = notification;

  useEffect(() => {
    if (isOpen && !inProgress) {
      setTimeout(() => {
        setNotification({
          isOpen: false,
          inProgress: false,
          message: "",
          severity: "none",
        });
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, inProgress]);

  const handleClose = () => {
    setNotification((previousNotification) => ({
      ...previousNotification,
      isOpen: false,
      inProgress: false,
    }));
  };

  const getColors = () => {
    const bgColor = `${severity}.main`;
    let color = "white";
    if (severity === "warning") color = "black";
    return { backgroundColor: bgColor, color };
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      open={isOpen}
      message={severity === "none" && message}
      id={`notification-${severity}`}
    >
      {severity !== "none" ? (
        <Alert
          sx={getColors()}
          onClick={handleClose}
          severity={severity}
          icon={false}
        >
          <Stack direction="row" gap={1} alignItems="center">
            {/* eslint-disable-next-line no-nested-ternary */}
            {severity === "success" ? (
              inProgress ? (
                <CircularProgress size={22} sx={{ color: "white" }} />
              ) : (
                <CheckCircleOutlineIcon sx={{ color: "white" }} />
              )
            ) : (
              <InfoOutlined sx={{ color: "white" }} />
            )}
            <Typography variant="body2">{message}</Typography>
          </Stack>
        </Alert>
      ) : (
        <span />
      )}
    </Snackbar>
  );
}

export default Notification;
